import $ from 'jquery';
import 'jquery-sticky';
import GoogleMapsApi from '../shared/GoogleMapsApi';
import Handlebars from "handlebars";
import  "geocomplete";

export default class {

    constructor(el) {
        this.el = el;

        this.settings = {
            url: '/webapi/search',
            dataParams: {
                city: 'city',
                state: 'state',
                coordinates: 'coordinates',
                zip: 'zip',
                name: 'name',
                address:'address'
            }
        };

        this.selectors = {
            input: '[data-input]',
            button: '[data-search-btn]',
            current: '[data-get-locate]',
            templateLoan: '#loan-template',
            templateBranch: '#branch-template',
            render: '[data-render-loan]',
            renderWrap: '[data-result-wrapper]',
            scrollTop: '[scroll-search]',
            error: '[data-error]'
        };

        this.data = {};

        this.initMaps();
    }

    init() {
      
        this.$elements = {
            input: this.el.find(this.selectors.input),
            button: this.el.find(this.selectors.button),
            render: $(this.selectors.render),
            renderWrap: $(this.selectors.renderWrap)
        };
        
        this.bind();
    }
    bind() {

        const _self = this;
        
        this.$elements.input.filter('[data-geocomplete]').geocomplete().bind("geocode:result", (event, result) => {
           const el = $(event.currentTarget),
               tab = this.el.find('[data-tab-item].active'),
               input = el,
                error = el.parents('.search-input--wrapper').find(this.selectors.error);

             let  data={
                 streetNumber: '',
                 streetName: '',
                 city: '',
                 state: '',
                 postalCode: '',
                 location: {
                     lat: '',
                     lng: ''
                 }
             };

            error.text('');
            let state = '';

            data.location = {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng()
            };

            $.each(result.address_components, (i, e) => {
                if ((e.types[0] === "administrative_area_level_1") || (e.types[0] == "country" && e.types[1] == "political" && e.long_name == "Guam")) {
                    state = e.short_name;
                    data.state = e.short_name;
                }
                else if (e.types[0] === "route") {
                    data.streetName = e.long_name;
                }
                else if (e.types[0] === "locality") {
                    data.city = e.long_name;
                }
                else if (e.types[0] === "street_number") {
                    data.streetNumber = e.long_name;
                }
                else if (e.types[0] === "postal_code") {
                    data.postalCode = e.long_name;
                }
            });
            el.attr('data-state', state);           

            this.data = this.getData(input, data);
            this.search().then((res) => {
                this.settings.activeTabs = tab.attr('data-val');

                this.render(res).then(() => {this.afterRender()});
            });
        });

        $(window).on({
            'state-change-trigger': (e) => {
                const tab = this.el.find('[data-tab-item].active'),
                    input = tab.find(this.selectors.input),
                    btn =  input.filter('[data-val="state"]').parent().find(this.selectors.button),
                    error = tab.find(this.selectors.error);
                input.attr('data-check', this.settings.dataParams.state)
                error.text('');
                input.filter('[data-val="state"]').val(e.detail.region);
                input.filter('[data-val="state"]').attr('data-state',e.detail.code);

                
                btn.trigger('click');
            }
        });

        this.el.on({
            'click': (e) => {
                e.preventDefault();

                const input = $(e.currentTarget).parent().find(this.selectors.input);
             
                const tab = this.el.find('[data-tab-item].active'),
                error = tab.find(this.selectors.error);
                error.text('');
                if(input.attr('data-check') === this.settings.dataParams.address && input.attr('data-val') !== 'name'){
                    input.geocomplete("find", input.val());                    
                }
                else {
                    if (input.attr('data-val') != 'name') {
                        const inputs1 = tab.find(this.selectors.input);
                        const btn1 = inputs1.filter('[data-val="name"]').parent().find(this.selectors.button);
                        inputs1.filter('[data-val="name"]').val("");
                        // inputs.filter('[data-val="name"]').attr('data-state', "");
                       // btn1.trigger('click');
                    }
                    if(input.attr('data-val') != 'state')
                    {
                        input.attr('data-state', input.val())
                        //code added to clear the input text
                        const inputs = tab.find(this.selectors.input);
                        const input2 = inputs.find('[data-val="state"]');
                        const btn2 = inputs.filter('[data-val="state"]').parent().find(this.selectors.button);
                        inputs.filter('[data-val="state"]').val("");
                        inputs.filter('[data-val="state"]').attr('data-state', "");
                        btn2.trigger('click');
                    }
                    this.data = this.getData(input);
                    this.search().then((res) => {
                        this.settings.activeTabs = tab.attr('data-val');
        
                        this.render(res).then(() => {this.afterRender()});
                    });
                }             
            }
        }, this.selectors.button);

        this.el.on('keypress', '[data-input][data-val="name"]', (e) => {            
            if (e.which === 13) {
                $(e.currentTarget).next().trigger('click');
            }
        });
        this.el.on('change', '[data-input][data-val="state"]', (e) => {
            const tab = this.el.find('[data-tab-item].active')
            const inputs1 = tab.find(this.selectors.input);
            const btn1 = inputs1.filter('[data-val="name"]').parent().find(this.selectors.button);
            inputs1.filter('[data-val="name"]').val("");
        });
        this.el.on('change', '[data-input][data-val="name"]', (e) => {
           
            const tab = this.el.find('[data-tab-item].active')
            const inputs = tab.find(this.selectors.input);
            const btn2 = inputs.filter('[data-val="state"]').parent().find(this.selectors.button);
            inputs.filter('[data-val="state"]').val("");
            inputs.filter('[data-val="state"]').attr('data-state', "");
           // btn2.trigger('click');
        });

        this.$elements.renderWrap.on({
            'click': (e) => {
                e.preventDefault();
                $("html, body").stop().animate({scrollTop:this.el.offset().top}, 500, 'swing');
             
            }
        }, this.selectors.scrollTop);

        this.el.on({
            'click': (e) => {
                e.preventDefault();

                if (navigator.geolocation) {
                    const tab = this.el.find('[data-tab-item].active'),
                        input = $(e.currentTarget).parent().find(this.selectors.input),
                        error = $(e.currentTarget).closest('.search-input--wrapper').find(this.selectors.error),
                        btn =   $(e.currentTarget).parent().find(this.selectors.button);
                      error.text('');

                    navigator.geolocation.getCurrentPosition((position) => {
                        const coord = position.coords.latitude + ',' + position.coords.longitude
                        //       input.attr('data-val', this.settings.dataParams.coordinates);
                        input.val(coord);
                        btn.trigger('click');
                    }, (e) => {
                        error.text(e.message);

                    });
                }
            }
        }, this.selectors.current);
    }

    //search() {
    //    return $.ajax({
    //        type: 'POST',
    //        url: this.settings.url,
    //        data: this.data,
    //        dataType:'json',
    //    }).promise();
    //}

    search() {
        return $.ajax({
            type: 'GET',
            url: `${this.settings.url}/${this.data.requestType}?searchType=${this.data.searchType}&userInput=${(this.data.searchType !== 'address' ? this.data.userInput : JSON.stringify(this.data.userInput))}`,
            dataType: 'json'
        }).promise();
    }

    afterRender() {
        const header = $('.site-navigator').height() + $('header').height()
        const top =  this.$elements.renderWrap.offset().top - header
        $("html, body").stop().animate({scrollTop:top}, 500, 'swing');
        this.$elements.renderWrap.find(this.selectors.scrollTop).sticky({topSpacing:header+20});
    
}
    getData($input , multipleData) {
        const tab = this.el.find('[data-tab-item].active');
        const input = $input;
        let data = {}
        data[tab.attr('data-name')] = tab.attr('data-val');
        if(multipleData) {
            data[input.attr('data-name')] = input.attr('data-check');
            data[input.attr('name')] = multipleData;
        }
        else {

            data[input.attr('data-name')] = input.attr('data-val');
            data[input.attr('name')] = input.attr('data-state');
        }
        if(input.attr('data-val') !== 'name')
            input.attr('data-check', this.settings.dataParams.address)
        return data;
        
    }

    render(context) {
        return new Promise((resolve, reject) => {
            let templateId;

            if (this.settings.activeTabs === 'branch') {
                templateId = this.selectors.templateBranch;
            } else {
                templateId = this.selectors.templateLoan;
            }
            let source = $(templateId).html();
            let template = Handlebars.compile(source);
            let html = template(context);

            this.$elements.renderWrap.removeClass('d-none');
            this.$elements.render.html(html);
            resolve(true);
        });
    }
    
    initMaps() {
        const gmapApi = new GoogleMapsApi();
        
        gmapApi.load().then(() => {
            this.init();
        });
    }
}